import React from "react";
import { Send } from "lucide-react";
import { useSparkPost } from "@/components/admin/sparkpost/useSparkPost";
import { SparkPostConnectForm, NoDomainNotice, NoZoneNotice } from "@/components/admin/sparkpost/SparkPostConnectForm";
import { SparkPostDnsMatrix } from "@/components/admin/sparkpost/SparkPostDnsMatrix";
import { SparkPostTestRow } from "@/components/admin/sparkpost/SparkPostTestRow";

/**
 * Per-site SparkPost connection panel with full DNS auto-onboarding (SPF, DKIM,
 * bounce/return-path CNAME, tracking CNAME). Empty state → connect form;
 * connected → live DNS matrix with Fix DNS / Verify all + test send / disconnect.
 */
export default function SparkPostPanel({ site, reload }) {
  const sp = useSparkPost(site, reload);

  if (!site.domain) return <NoDomainNotice />;
  if (!site.cloudflare_zone_id) return <NoZoneNotice />;

  return (
    <div className="border border-zinc-800 bg-zinc-900/40 rounded-sm p-5 space-y-4" data-testid="sparkpost-panel">
      <div className="flex items-center gap-3">
        <Send size={18} className="text-emerald-400" />
        <div className="font-display text-lg font-bold">SparkPost transactional email</div>
        {sp.connected && <span className="dot bg-emerald-500 ml-auto" data-testid="sparkpost-connected-dot" />}
      </div>

      {sp.connected ? (
        <>
          <SparkPostDnsMatrix matrix={sp.matrix} busy={sp.busy} busyRow={sp.busyRow} fixDns={sp.fixDns} verifyAll={sp.verifyAll} refreshMatrix={sp.refreshMatrix} />
          <SparkPostTestRow busy={sp.busy} sendTest={sp.sendTest} disconnect={sp.disconnect} />
        </>
      ) : (
        <SparkPostConnectForm domain={site.domain} busy={sp.busy} onConnect={sp.connect} setErr={sp.setErr} />
      )}

      {sp.msg && <div className="text-xs text-emerald-400 mono" data-testid="sparkpost-msg">{sp.msg}</div>}
      {sp.err && <div className="text-xs text-red-400 mono" data-testid="sparkpost-err">{sp.err}</div>}
    </div>
  );
}
